import PropTypes from 'prop-types';

import PropTypesPresenter from '../utils/PropTypesPresenter';

export default new PropTypesPresenter({
  id: PropTypes.number,
  project_id: PropTypes.number,
  name: PropTypes.string,
  description: PropTypes.string,
  data_group_id: PropTypes.number,
  count: PropTypes.number,
  is_visible: PropTypes.number,
  created: PropTypes.string,
});
